/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-11-03 16:23:02
 */
import { useEffect } from 'react'
import { fetchGroupLimitInfo } from '../../actions/group'
import { useAppDispatch, useAppSelector } from '../hooks'
import { setGroupLimitInfo } from '../../slices/groupLimitSlice'

export const useGroupLimitInfo = () => {
  const dispatch = useAppDispatch()
  const groupID = useAppSelector((state) => state.group.groupId)

  useEffect(() => {
    dispatch(fetchGroupLimitInfo({ groupID: groupID })).then((data) => {
      dispatch(setGroupLimitInfo(data))
    })
  }, [groupID])

  return null
}
